import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './SubNavbar.css';

const SubNavbar = () => {
  const location = useLocation();

  let buttons = [];

  if (location.pathname.startsWith('/kiosko')) {
    buttons = [
      { label: 'Inicia Servicio', path: '/kiosko/iniciar' },
      { label: 'Concluir Servicio', path: '/kiosko/concluir' },
    ];
  } else if (location.pathname.startsWith('/coordinacion')) {
    buttons = [
      { label: 'Salida', path: '/operacion/iniciar' },
      { label: 'Llegadas', path: '/coordinacion/llegadaspage' },
      { label: 'Gestión', path: '/operacion/gestion' },
    ];
  } else if (location.pathname.startsWith('/handheld')) {
    buttons = [
      { label: 'Bitácora', path: '/handheld/bitacora' },
      { label: 'Salidas', path: '/handheld/salidas' },
      { label: 'Llegadas', path: '/handheld/llegadas' },
      { label: 'Gestión', path: '/handheld/gestion' },
      { label: 'Manual', path: '/handheld/manual' },
      { label: 'Pendientes', path: '/handheld/pendientes'}
    ];
  }

  if (buttons.length === 0) return null; // No muestra subnavbar fuera de estas rutas

  return (
    <div className="subnavbar">
      {buttons.map((btn) => (
        <Link key={btn.path} to={btn.path} className="subnav-button">
          {btn.label}
        </Link>
      ))}
    </div>
  );
};

export default SubNavbar;
